import React, { useEffect, useState, useRef } from "react";
import { Constants, createCameraVideoTrack } from "@videosdk.live/react-sdk";
import { sideBarModes } from "../../utils/common";
import SettingsPanel from "./SettingsPanel";
import MobileBottomBar from "./MobileBottomBar";
import MobileSwipeUpPanel from "./MobileSwipeUpPanel";
import CaptionTranslationPanel from "./CaptionTranslationPanel";
import { backgroundImageUrls } from "../../utils/background";
import { emojis } from "../../utils/list";
import ToolsDropdown from "./ToolsDropdown";
import { useTopBar } from "../../hooks/useTopBar";
import * as meetingServices from "../../services/meetingServices";
import { isLanguageSupported } from "stream-chat-react";
import * as virtualBackgroundServices from "../../services/virtualBackgroundServices";
import { toast } from "react-toastify";
import { createPortal } from "react-dom";
import BreakoutRoomsModal from "../../components/breakout-rooms/BreakoutRoomsModal";
import BreakoutRoomsParticipantPanel from "../../components/breakout-rooms/BreakoutRoomsParticipantPanel";

const TopBar = (props) => {
  const {
    // Context values
    meetingRole,
    user,
    isAuthenticated,
    meetingSettings,
    showElementSection,
    setShowElementSection,
    selectedLayout,
    setSelectedLayout,
    hideSelfView,
    setHideSelfView,
    showNonVideoParticipants,
    setShowNonVideoParticipants,
    videoResolution,
    handleVideoResolution,
    translationStatus,
    showPollsModal,
    setShowPollsModal,
    polls,
    selectedPoll,
    setSelectedPoll,
    loadingPolls,
    showPollResultsModal,
    setShowPollResultsModal,
    pollResults,
    meetingSession,
    setMeetingSettings,

    // Meeting app context
    selectedMic,
    setSelectedMic,
    selectedSpeaker,
    setSelectedSpeaker,
    setSideBarMode,
    setLeftSideBarMode,
    leftSideBarMode,
    selectedWebcam,
    setSelectedWebcam,
    setUnreadChat,
    unreadChat,
    recentReactions,
    selectedLanguage,
    setSelectedLanguage,
    setTranslationEnabled,
    translationEnabled,
    setTranscriptionEnabled,
    transcriptionEnabled,
    virtualBackgroundOn,
    approvalSoundEnabled,
    setApprovalSoundEnabled,
    aiNoiseRemovalEnabled,
    setAiNoiseRemovalEnabled,
    showRecordingConsentModal,
    setShowRecordingConsentModal,
    participantApproveFunc,

    // Local state
    isMobile,
    isMobileLike,
    isMobileLandscape,
    mics,
    speakers,
    localMicOn,
    changeMic,
    localWebcamOn,
    changeWebcam,
    showMore,
    setShowMore,
    showSetting,
    setShowSetting,
    showVirtualBackgroundModal,
    setShowVirtualBackgroundModal,
    showLeaveModal,
    setShowLeaveModal,
    webcams,
    showReactions,
    setShowReactions,
    showToolsDropdown,
    setShowToolsDropdown,
    showCaptionsDropdown,
    setShowCaptionsDropdown,
    showMicDropdown,
    setShowMicDropdown,
    showSpeakerDropdown,
    setShowSpeakerDropdown,
    showVideoDropdown,
    setShowVideoDropdown,
    showLayoutDropdown,
    setShowLayoutDropdown,
    showMobilePanel,
    showCaptionTranslationPanel,
    setShowCaptionTranslationPanel,
    setShowMobilePanel,
    isFullscreen,
    setIsFullscreen,
    compactMode,
    setCompactMode,
    showHelpModal,
    setShowHelpModal,
    helpIssueText,
    setHelpIssueText,
    showProfileConfirmModal,
    setShowProfileConfirmModal,

    // Live streaming
    showLiveStreamModal,
    setShowLiveStreamModal,
    isLiveStreaming,
    liveStreamPlatforms,
    setLiveStreamPlatforms,
    streamingCredentials,
    setStreamingCredentials,
    streamingStartTime,
    streamingElapsedMs,

    // Recording
    showAudioInputDropdown,
    setShowAudioInputDropdown,
    showVideoSourceDropdown,
    setShowVideoSourceDropdown,
    blurEnabled,
    setBlurEnabled,
    blurStrength,
    setBlurStrength,
    selectedBackground,
    showStartRecordingModal,
    setShowStartRecordingModal,
    recordingStartAt,
    recordingElapsedMs,
    isRecording,

    // Meeting
    mMeeting,
    startWhiteboard,
    isRequestProcessing,
    resolvedSessionId,

    // PubSub
    publishRaiseHand,
    publishReaction,

    // Handlers
    handleHelpSubmit,
    handleRecordingClick,
    handleConfirmStartRecording,
    handleStopRecording,
    formatDuration,
    handleStartLiveStream,
    handleStopLiveStream,
    handleLaunchPoll,
    getMics,
    getWebcams,
    handleToggleFullscreen,
    handleCopyRoomLink,
    handleToggleTranscription,
    handleToggleMic,
    isTogglingMic,
    handleToggleWebcam,
    isTogglingWebcam,
    handleStartVirtualBackground,
    handleLeaveModal,
    handleLeaveConfirm,
    handleEndForAll,
    handleLeaveCancel,
    handleEmojiClick,
    onTouchStart,
    onTouchMove,
    onTouchEnd,

    // Props passthrough
    startTranscription,
    stopTranscription,
    startTranslation,
    stopTranslation,
    changeTranslationLanguage,
    publishMeetingSettings,
    webcamOn,
    customVideoStream,
    customAudioStream,
    setIsMeetingLeft,
  } = useTopBar(props);

  // State for custom virtual backgrounds
  const [customBackgrounds, setCustomBackgrounds] = useState([]);

  // State for Breakout Rooms Modal - managed at TopBar level so it persists when ToolsDropdown closes
  const [showBreakoutRoomsModal, setShowBreakoutRoomsModal] = useState(false);
  const [uploadingBackground, setUploadingBackground] = useState(false);
  const [showImageSizeInfoDialog, setShowImageSizeInfoDialog] = useState(false);
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [backgroundToDelete, setBackgroundToDelete] = useState(null);
  const fileInputRef = useRef(null);

  console.log(mics);


  // Fetch custom backgrounds
  useEffect(() => {
    if (isAuthenticated) {
      fetchCustomBackgrounds();
    }
  }, [isAuthenticated]);

  // Fetch custom backgrounds
  const fetchCustomBackgrounds = async () => {
    try {
      const response =
        await virtualBackgroundServices.getUserVirtualBackgrounds();
      if (response.success && response.data) {
        setCustomBackgrounds(response.data);
      }
    } catch (error) {
      console.error("Error fetching custom backgrounds:", error);
    }
  };

  // Handle file upload
  const handleFileUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file type
    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "image/gif",
      "image/webp",
    ];
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only image files (JPEG, PNG, GIF, WebP) are allowed");
      return;
    }

    // Validate file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      toast.error("File size must be less than 10MB");
      return;
    }

    setUploadingBackground(true);
    try {
      const response = await virtualBackgroundServices.uploadVirtualBackground(
        file
      );
      if (response.success) {
        toast.success("Background uploaded successfully!");
        // Add to custom backgrounds list
        setCustomBackgrounds((prev) => [response.data, ...prev]);
        // Reset file input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        toast.error(response.message || "Failed to upload background");
      }
    } catch (error) {
      console.error("Error uploading background:", error);
      toast.error(
        error.response?.data?.message || "Failed to upload background"
      );
    } finally {
      setUploadingBackground(false);
    }
  };

  // Handle delete custom background - show confirmation modal
  const handleDeleteBackground = (backgroundId, event) => {
    event.stopPropagation();
    setBackgroundToDelete(backgroundId);
    setShowDeleteConfirmModal(true);
  };

  // Confirm and execute delete
  const confirmDeleteBackground = async () => {
    if (!backgroundToDelete) return;

    try {
      const response = await virtualBackgroundServices.deleteVirtualBackground(
        backgroundToDelete
      );
      if (response.success) {
        toast.success("Background deleted successfully");
        // Remove from custom backgrounds list
        setCustomBackgrounds((prev) =>
          prev.filter((bg) => (bg._id || bg.id) !== backgroundToDelete)
        );
      } else {
        toast.error(response.message || "Failed to delete background");
      }
    } catch (error) {
      console.error("Error deleting background:", error);
      toast.error(
        error.response?.data?.message || "Failed to delete background"
      );
    } finally {
      setShowDeleteConfirmModal(false);
      setBackgroundToDelete(null);
    }
  };

  // Toggle Row Components
  const TranscriptionToggleRow = ({ variant = "dark", className = "" }) => {
    const isLight = variant === "light";
    const labelColor = isLight ? "text-slate-800" : "text-white";
    const switchBackground = transcriptionEnabled
      ? "bg-[#7c3aed] shadow-[0_0_0_4px_rgba(124,58,237,0.25)]"
      : isLight
        ? "bg-slate-300"
        : "bg-gray-600";
    const thumbTransform = transcriptionEnabled
      ? "translate-x-[1.4rem]"
      : "translate-x-1";
    const thumbStyles = transcriptionEnabled
      ? "bg-white shadow-[0_6px_14px_rgba(124,58,237,0.35)]"
      : "bg-white shadow-sm";

    return (
      <div
        className={`w-full px-3 py-2 flex items-center justify-between gap-4 ${className}`}
      >
        <span className={`font-medium leading-5 ${labelColor}`}>
          Show Transcription
        </span>
        <button
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.stopPropagation();
            handleToggleTranscription();
          }}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#7700ff]/40 ${switchBackground}`}
          role="switch"
          aria-checked={transcriptionEnabled}
          aria-label={
            transcriptionEnabled ? "live transcription" : "live transcription"
          }
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full transition-all duration-200 ease-out ${thumbTransform} ${thumbStyles}`}
          />
        </button>
      </div>
    );
  };

  const WaitingRoomToggleRow = ({ variant = "dark", className = "" }) => {
    const isLight = variant === "light";
    const labelColor = isLight ? "text-slate-800" : "text-white";
    const switchBackground = meetingSettings?.hostApprovalRequired
      ? "bg-[#7c3aed] shadow-[0_0_0_4px_rgba(124,58,237,0.25)]"
      : isLight
        ? "bg-slate-300"
        : "bg-gray-600";
    const thumbTransform = meetingSettings?.hostApprovalRequired
      ? "translate-x-[1.4rem]"
      : "translate-x-1";
    const thumbStyles = meetingSettings?.hostApprovalRequired
      ? "bg-white shadow-[0_6px_14px_rgba(124,58,237,0.35)]"
      : "bg-white shadow-sm";

    return (
      <div
        className={`w-full px-3 py-2 flex items-center justify-between gap-4 ${className}`}
      >
        <span className={` font-medium leading-5 ${labelColor}`}>
          {meetingSettings?.hostApprovalRequired
            ? "Waiting Room"
            : "Waiting Room"}
        </span>
        <button
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.stopPropagation();
            setMeetingSettings((prev) => {
              const newValue = !prev?.hostApprovalRequired;
              const updatedSettings = {
                ...prev,
                hostApprovalRequired: newValue,
              };
              // Sync via PubSub across all participants using current meeting settings
              publishMeetingSettings(
                JSON.stringify({
                  data: updatedSettings,
                })
              );

              meetingServices.updateMeetingSessionSettings({
                meetingId: meetingSettings?.roomId,
                hostApprovalRequired: newValue,
                guestCanUnmute: meetingSettings?.guestCanUnmute,
              });
              return updatedSettings;
            });
          }}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#7700ff]/40 ${switchBackground}`}
          role="switch"
          aria-checked={meetingSettings?.hostApprovalRequired}
          aria-label={
            meetingSettings?.hostApprovalRequired
              ? "Waiting Room"
              : "Waiting Room"
          }
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full transition-all duration-200 ease-out ${thumbTransform} ${thumbStyles}`}
          />
        </button>
      </div>
    );
  };

  const GuestCanUnmuteToggleRow = ({ variant = "dark", className = "" }) => {
    const isLight = variant === "light";
    const labelColor = isLight ? "text-slate-800" : "text-white";
    const switchBackground = meetingSettings?.guestCanUnmute
      ? "bg-[#7c3aed] shadow-[0_0_0_4px_rgba(124,58,237,0.25)]"
      : isLight
        ? "bg-slate-300"
        : "bg-gray-600";
    const thumbTransform = meetingSettings?.guestCanUnmute
      ? "translate-x-[1.4rem]"
      : "translate-x-1";
    const thumbStyles = meetingSettings?.guestCanUnmute
      ? "bg-white shadow-[0_6px_14px_rgba(124,58,237,0.35)]"
      : "bg-white shadow-sm";

    return (
      <div
        className={`w-full px-3 py-2 flex items-center justify-between gap-4 ${className}`}
      >
        <span className={`font-medium leading-5 ${labelColor}`}>
          {meetingSettings?.guestCanUnmute ? "Guest Unmute" : "Guest Unmute"}
        </span>
        <button
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.stopPropagation();
            setMeetingSettings((prev) => {
              const newValue = !prev?.guestCanUnmute;
              const updatedSettings = {
                ...prev,
                guestCanUnmute: newValue,
              };
              // Sync via PubSub across all participants using current meeting settings
              publishMeetingSettings(
                JSON.stringify({
                  data: updatedSettings,
                }),
              );

              meetingServices.updateMeetingSessionSettings({
                meetingId: meetingSettings?.roomId,
                guestCanUnmute: newValue,
                hostApprovalRequired: meetingSettings?.hostApprovalRequired,
              });
              return updatedSettings;
            });
          }}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#7700ff]/40 ${switchBackground}`}
          role="switch"
          aria-checked={meetingSettings?.guestCanUnmute}
          aria-label={
            meetingSettings?.guestCanUnmute ? "Guest Unmute" : "Guest Unmute"
          }
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full transition-all duration-200 ease-out ${thumbTransform} ${thumbStyles}`}
          />
        </button>
      </div>
    );
  };

  const ApprovalSoundToggleRow = ({ variant = "dark", className = "" }) => {
    const isLight = variant === "light";
    const labelColor = isLight ? "text-slate-800" : "text-white";
    const switchBackground = approvalSoundEnabled
      ? "bg-[#7c3aed] shadow-[0_0_0_4px_rgba(124,58,237,0.25)]"
      : isLight
        ? "bg-slate-300"
        : "bg-gray-600";
    const thumbTransform = approvalSoundEnabled
      ? "translate-x-[1.4rem]"
      : "translate-x-1";
    const thumbStyles = approvalSoundEnabled
      ? "bg-white shadow-[0_6px_14px_rgba(124,58,237,0.35)]"
      : "bg-white shadow-sm";

    return (
      <div
        className={`w-full px-3 py-2 flex items-center justify-between gap-4 ${className}`}
      >
        <span className={`font-medium leading-5 ${labelColor}`}>
          Approval Sound
        </span>
        <button
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.stopPropagation();
            setApprovalSoundEnabled((prev) => !prev);
          }}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#7700ff]/40 ${switchBackground}`}
          role="switch"
          aria-checked={approvalSoundEnabled}
          aria-label={
            approvalSoundEnabled ? "Approval Sound" : "Approval Sound"
          }
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full transition-all duration-200 ease-out ${thumbTransform} ${thumbStyles}`}
          />
        </button>
      </div>
    );
  };

  const AINoiseRemovalToggleRow = ({ variant = "dark", className = "" }) => {
    const isLight = variant === "light";
    const labelColor = isLight ? "text-slate-800" : "text-white";
    const switchBackground = aiNoiseRemovalEnabled
      ? "bg-[#7c3aed] shadow-[0_0_0_4px_rgba(124,58,237,0.25)]"
      : isLight
        ? "bg-slate-300"
        : "bg-gray-600";
    const thumbTransform = aiNoiseRemovalEnabled
      ? "translate-x-[1.4rem]"
      : "translate-x-1";
    const thumbStyles = aiNoiseRemovalEnabled
      ? "bg-white shadow-[0_6px_14px_rgba(124,58,237,0.35)]"
      : "bg-white shadow-sm";

    return (
      <div
        className={`w-full px-3 py-2 flex items-center justify-between gap-4 ${className}`}
      >
        <span className={`font-medium leading-5 ${labelColor}`}>
          AI Noise Removal
        </span>
        <button
          onMouseDown={(event) => {
            event.stopPropagation();
          }}
          onClick={(event) => {
            event.stopPropagation();
            setAiNoiseRemovalEnabled((prev) => !prev);
          }}
          className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-[#7700ff]/40 ${switchBackground}`}
          role="switch"
          aria-checked={aiNoiseRemovalEnabled}
          aria-label={
            aiNoiseRemovalEnabled ? "AI Noise Removal" : "AI Noise Removal"
          }
        >
          <span
            className={`inline-block h-4 w-4 transform rounded-full transition-all duration-200 ease-out ${thumbTransform} ${thumbStyles}`}
          />
        </button>
      </div>
    );
  };

  return (
    <div
      className={`select-none sticky top-0 w-full z-[10001] border-b border-[#39364A] px-1 sm:px-2 md:px-3 lg:px-4 xl:px-6 bg-black text-white flex items-center relative ${compactMode
        ? "h-[40.97px]  transition-all duration-300 ease-in-out"
        : "h-16 md:h-[60px] transition-all duration-300 ease-in-out"
        }`}
    >
      {/* Notch with curved border */}
      {!isMobileLike && (
        <div className="absolute left-1/2 -translate-x-1/2 -bottom-[7px] w-[60px] h-[7px] z-30">
          <div
            className="relative w-full h-full bg-black rounded-b-full border-x border-b border-[#39364A] shadow-sm flex items-center justify-center cursor-pointer"
            onClick={() => setCompactMode(!compactMode)}
          >
            <img
              src="/icons/chevronDown.svg"
              alt="Toggle compact mode"
              className={`mb-1 transition-transform duration-300 ease-in-out ${!compactMode ? "rotate-180" : ""
                }`}
            />
          </div>
        </div>
      )}
      {/* Recording pill with timer (centered) */}
      {isRecording && (
        <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 flex items-center gap-2 bg-transparent border border-[#39364A] text-white px-3 py-1.5 rounded-lg shadow-lg">
          <span className="inline-block w-2 h-2 bg-red-500 rounded-xl animate-pulse" />
          <span className="text-[10px] tracking-widest text-gray-300">
            RECORDING
          </span>
          <span className="text-[10px] font-mono text-white">
            {formatDuration(recordingElapsedMs)}
          </span>
          {meetingRole === "moderator" && (
            <>
              {/* <button
                onClick={handlePauseRecording}
                className="ml-2 flex items-center justify-center w-4 h-4 text-gray-300 hover:text-white transition-colors"
                title={isRecordingPaused ? "Resume" : "Pause"}
                aria-label={
                  isRecordingPaused ? "Resume recording" : "Pause recording"
                }
              >
                {isRecordingPaused ? (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M8 5v14l11-7z" />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                  >
                    <path d="M6 4h4v16H6V4zm8 0h4v16h-4V4z" />
                  </svg>
                )}
              </button> */}
              {/* Stop button */}
              <button
                onClick={handleStopRecording}
                className="flex items-center justify-center w-3 h-3 text-gray-300 hover:text-white transition-colors bg-[#7700FF]"
                title="Stop Recording"
                aria-label="Stop recording"
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="#7700FF">
                  <path d="M6 6h12v12H6z" />
                </svg>
              </button>
            </>
          )}
        </div>
      )}

      {/* Live Streaming pill with timer (centered, below recording if both active) */}
      {isLiveStreaming && (
        <div
          className={`absolute left-1/2 -translate-x-1/2 ${isRecording ? "top-[70%]" : "top-1/2"
            } -translate-y-1/2 flex items-center gap-2 bg-[#1a1a2e] border border-[#39364A] text-white px-3 py-1.5 rounded-full shadow-lg`}
        >
          <span className="inline-block w-2 h-2 bg-red-500 rounded-full animate-pulse" />
          <span className="text-[10px] tracking-widest text-gray-300">
            LIVE
          </span>
          <div className="flex items-center gap-1">
            {liveStreamPlatforms.facebook && (
              <span className="text-[8px] bg-blue-600 px-1 py-0.5 rounded">
                FB
              </span>
            )}
            {liveStreamPlatforms.youtube && (
              <span className="text-[8px] bg-red-600 px-1 py-0.5 rounded">
                YT
              </span>
            )}
            {liveStreamPlatforms.linkedin && (
              <span className="text-[8px] bg-blue-700 px-1 py-0.5 rounded">
                LI
              </span>
            )}
          </div>
          <span className="text-[10px] font-mono text-white">
            {formatDuration(streamingElapsedMs)}
          </span>
          {meetingRole === "moderator" && (
            <button
              onClick={handleStopLiveStream}
              className="ml-2 flex items-center justify-center w-4 h-4 text-gray-300 hover:text-white transition-colors"
              title="Stop Live Stream"
              aria-label="Stop live stream"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M6 6h12v12H6z" />
              </svg>
            </button>
          )}
        </div>
      )}
      {/* Left Section */}
      <div className="flex items-center justify-center w-3/7 h-full">
        <img
          alt="R-Link"
          className={`hidden lg:block  w-auto mr-8 xl:mr-10 2xl:mr-12 ${compactMode ? "h-8" : "h-10"
            } transition-all duration-300 ease-in-out`}
          src={`${compactMode ? "/icons/logoCompact.svg" : "/icons/logoFull.svg"
            }`}
        />
        {/* Mobile Logo */}
        <img
          alt="R-Link"
          className="lg:hidden h-6 sm:h-7 md:h-8 w-auto ml-2 sm:mr-8"
          src="/r-link-fav.svg"
        />
        <div
          className={`${isMobileLike ? "hidden" : "flex"
            } items-center justify-center transition-all duration-300 ease-in-out h-full ${compactMode
              ? "gap-2 lg:gap-2.5 xl:gap-3 2xl:gap-4"
              : "gap-1.5 lg:gap-2 xl:gap-2.5 2xl:gap-3"
            }`}
        >
          <div className="relative h-full">
            <div className="h-full flex items-center px-2 text-slate-300 hover:text-white">
              {/* MIC TOGGLE */}
              <button
                onClick={handleToggleMic}
                disabled={isTogglingMic}
                className="flex flex-col items-center justify-center h-full disabled:opacity-50 disabled:cursor-not-allowed"
                title={localMicOn ? "Mute" : "Unmute"}
                aria-label={localMicOn ? "Mute" : "Unmute"}
              >
                <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                  <img
                    src={
                      localMicOn ? "/icons/micOn.svg" : "/icons/micOff.svg"
                    }
                    alt={localMicOn ? "Mute" : "Unmute"}
                    draggable={false}
                  />
                </div>

                {!compactMode && (
                  <span className="mt-1 text-[8px] sm:text-[10px] text-[#E0E0E0]">
                    Mic
                  </span>
                )}
              </button>

              {/* DROPDOWN ARROW */}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowMicDropdown(!showMicDropdown);
                  setShowVideoDropdown(false);
                  setShowSpeakerDropdown(false);
                }}
                onMouseDown={(e) => e.stopPropagation()}
                className="ml-1 flex items-center justify-center p-1"
                title="Mic Settings"
                aria-label="Mic Settings"
              >
                <img
                  src="/icons/chevronDown.svg"
                  alt="dropdown"
                  className={`transition-transform duration-200 ${showMicDropdown ? "rotate-180" : ""
                    }`}
                  draggable={false}
                />
              </button>
            </div>

            {/* Mic Device Dropdown */}
            {showMicDropdown && (
              <div
                data-mic-dropdown
                className={`absolute top-full left-0 mt-2 w-64 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 transition-all duration-300 ease-in-out`}
              >
                {/* Audio Input Section */}
                <div className="px-4 py-2">
                  <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                    AUDIO INPUT
                  </div>
                  <div className="relative">
                    <div
                      className="flex items-center justify-between w-full px-3 py-3 bg-[#1a1a2e] border border-white/30 rounded-lg text-white text-sm"
                      onClick={() => {
                        setShowAudioInputDropdown(!showAudioInputDropdown);
                        setShowToolsDropdown(false);
                        setShowLayoutDropdown(false);
                        setShowVideoDropdown(false);
                        setShowMore(false);
                      }}
                    >
                      <div className="flex items-center gap-3 min-w-0 flex-1">
                        <img
                          src="/icons/micOn.svg"
                          alt="Microphone"
                          className="flex-shrink-0"
                        />
                        <span className="font-medium truncate min-w-0">
                          {selectedMic?.label || "Select microphone"}
                        </span>
                      </div>

                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        className="flex-shrink-0 ml-2"
                      >
                        <path
                          d="M3.5 5.5L8 10l4.5-4.5"
                          stroke="currentColor"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"
                        />
                      </svg>
                    </div>

                    {/* Device List */}
                    {showAudioInputDropdown && (
                      <div className="absolute top-full left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-[#060621] border border-gray-600 rounded-lg shadow-xl z-10">
                        {mics.map((device) => (
                          <button
                            key={device.deviceId}
                            className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-3 min-w-0"
                            onClick={() => {
                              changeMic(device.deviceId);
                              setShowMicDropdown(false);
                              setSelectedMic({
                                id: device.deviceId,
                                label: device.label,
                              });
                            }}
                          >
                            <img
                              src="/icons/micOn.svg"
                              alt="Microphone"
                              className="flex-shrink-0"
                            />
                            <span className="truncate min-w-0">
                              {device.label ||
                                `Microphone ${device.deviceId.slice(0, 8)}...`}
                            </span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Audio Output Section */}
                <div className="px-4 py-2">
                  <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                    AUDIO OUTPUT
                  </div>
                  <div className="relative">
                    <button
                      onClick={() =>
                        setShowSpeakerDropdown(!showSpeakerDropdown)
                      }
                      className="flex items-center justify-between w-full px-3 py-3 bg-[#1a1a2e] border border-white/30 rounded-lg text-white text-sm hover:bg-[#1a1a2e]/80 transition-colors min-w-0"
                    >
                      <div className="flex items-center gap-3 min-w-0 flex-1">
                        <svg
                          className="w-5 h-5 text-white flex-shrink-0"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                        </svg>
                        <span className="font-medium truncate min-w-0">
                          {selectedSpeaker?.label || "Select speaker"}
                        </span>
                      </div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        className={`flex-shrink-0 ml-2 transition-transform duration-200 ${showSpeakerDropdown ? "rotate-180" : ""
                          }`}
                      >
                        <path
                          d="M3.5 5.5L8 10l4.5-4.5"
                          stroke="currentColor"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"
                        />
                      </svg>
                    </button>

                    {/* Speaker List */}
                    {showSpeakerDropdown && (
                      <div className="absolute top-full left-0 right-0 mt-2 max-h-48 overflow-y-auto bg-[#060621] border border-gray-600 rounded-lg shadow-xl z-10 transition-all duration-300 ease-in-out">
                        {speakers.map((device) => (
                          <button
                            key={device.deviceId}
                            className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-3 min-w-0"
                            onClick={() => {
                              setSelectedSpeaker({
                                id: device.deviceId,
                                label: device.label,
                              });
                              setShowSpeakerDropdown(false);
                            }}
                          >
                            <svg
                              className="w-4 h-4 text-white flex-shrink-0"
                              fill="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                            </svg>
                            <span className="truncate min-w-0">
                              {device.label ||
                                `Speaker ${device.deviceId.slice(0, 8)}...`}
                            </span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Refresh Devices Button */}
                <div className="px-4 py-2">
                  <button
                    onClick={() => {
                      getMics();
                      setShowMicDropdown(false);
                    }}
                    className="flex items-center gap-2 w-full px-4 py-3 bg-[#3A285F] text-white text-sm rounded-lg hover:bg-[#3A285F]/80 transition-colors"
                  >
                    <img
                      src="/icons/refresh.png"
                      alt="Refresh Devices"
                      className=""
                    />
                    <span className="font-medium">REFRESH DEVICES</span>
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="relative h-full">
            <div className="h-full flex items-center px-2 text-slate-300 hover:text-white">
              {/* VIDEO TOGGLE */}
              <button
                onClick={async () => {
                  await handleToggleWebcam({
                    handleVideoResolution,
                    mMeeting,
                    createCameraVideoTrack,
                    videoResolution,
                  });
                }}
                disabled={isTogglingWebcam}
                className="flex flex-col items-center justify-center h-full disabled:opacity-50 disabled:cursor-not-allowed"
                title={localWebcamOn ? "Camera Off" : "Camera On"}
                aria-label={localWebcamOn ? "Camera Off" : "Camera On"}
              >
                <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                  <img
                    src={
                      localWebcamOn
                        ? "/icons/videoCamera.svg"
                        : "/icons/videoOff.svg"
                    }
                    alt={localWebcamOn ? "Camera Off" : "Camera On"}
                    draggable={false}
                  />
                </div>

                {!compactMode && (
                  <span className="mt-1 text-[8px] sm:text-[10px] text-[#E0E0E0]">
                    Video
                  </span>
                )}
              </button>

              {/* DROPDOWN ARROW */}
              <button
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();

                  setShowVideoDropdown((prev) => !prev);
                  setShowMicDropdown(false);
                  setShowToolsDropdown(false);
                  setShowLayoutDropdown(false);
                  setShowMore(false);
                }}
                onMouseDown={(e) => e.stopPropagation()}
                className="ml-1 flex items-center justify-center p-1"
                title="Video Settings"
                aria-label="Video Settings"
              >
                <img
                  src="/icons/chevronDown.svg"
                  alt="dropdown"
                  className={`transition-transform duration-200 ${showVideoDropdown ? "rotate-180" : ""
                    }`}
                  draggable={false}
                />
              </button>
            </div>

            {/* Video Device Dropdown */}
            {showVideoDropdown && (
              <div
                data-video-dropdown
                className={`absolute top-full left-0 mt-2 w-64 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 transition-all duration-300 ease-in-out`}
              >
                {/* Video Source Section */}
                <div className="px-4 py-2">
                  <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                    VIDEO SOURCE
                  </div>
                  <div className="relative">
                    <div
                      className="flex items-center justify-between w-full px-3 py-3 bg-[#1a1a2e] border border-white/30 rounded-lg text-white text-sm"
                      onClick={() => {
                        setShowVideoSourceDropdown(!showVideoSourceDropdown);
                      }}
                    >
                      <div className="flex items-center gap-3 min-w-0 flex-1">
                        <img
                          src="/icons/videoCamera.svg"
                          alt="Camera"
                          className="flex-shrink-0"
                        />
                        <span className="font-medium truncate min-w-0">
                          {selectedWebcam?.label || "Select camera"}
                        </span>
                      </div>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        focusable="false"
                        className="flex-shrink-0 ml-2"
                      >
                        <path
                          d="M3.5 5.5L8 10l4.5-4.5"
                          stroke="currentColor"
                          stroke-width="1.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          fill="none"
                        />
                      </svg>
                    </div>

                    {/* Camera List */}
                    {showVideoSourceDropdown && (
                      <div className="absolute top-full left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-[#060621] border border-gray-600 rounded-lg shadow-xl z-10">
                        {webcams.map((device) => (
                          <button
                            key={device.deviceId}
                            className="w-full text-left px-3 py-2 text-sm text-white hover:bg-white/10 transition-colors flex items-center gap-3 min-w-0"
                            onClick={() => {
                              changeWebcam(device.deviceId);
                              setShowVideoDropdown(false);
                              setSelectedWebcam({
                                id: device.deviceId,
                                label: device.label,
                              });
                            }}
                          >
                            <img
                              src="/icons/videoCamera.svg"
                              alt="Camera"
                              className="flex-shrink-0"
                            />
                            <span className="truncate min-w-0">
                              {device.label ||
                                `Camera ${device.deviceId.slice(0, 8)}...`}
                            </span>
                          </button>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Mirror Camera View Option */}
                <div className="px-4 py-2">
                  <div className="flex items-center gap-3">
                    <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                    <span className="text-white text-sm">
                      Mirror Camera View
                    </span>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="px-4 py-2 space-y-2">
                  <button
                    onClick={() => {
                      setShowVirtualBackgroundModal(true);
                      setShowVideoDropdown(false);
                    }}
                    className="flex items-center gap-2 w-full px-4 py-3 bg-[#3A285F] text-white text-sm rounded-lg hover:bg-[#3A285F]/80 transition-colors"
                  >
                    <img
                      src="/icons/changeBg.png"
                      alt="Change Background"
                      className="w-4 h-4"
                    />
                    <span className="font-medium">CHANGE BACKGROUND</span>
                  </button>

                  <button
                    onClick={() => {
                      getWebcams();
                      setShowVideoDropdown(false);
                    }}
                    className="flex items-center gap-2 w-full px-4 py-3 bg-[#3A285F] text-white text-sm rounded-lg hover:bg-[#3A285F]/80 transition-colors"
                  >
                    <img
                      src="/icons/refresh.png"
                      alt="Refresh Devices"
                      className=""
                    />
                    <span className="font-medium">REFRESH DEVICES</span>
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* {!isMobile &&
            (["moderator", "co-host"].includes(meetingRole) ||
              (meetingSettings && meetingSettings.allowScreenSharing)) && (
              <div className="relative">
                <button
                  onClick={() => {
                    mMeeting.toggleScreenShare();
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title="Share"
                  aria-label="Share"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/shareScreen.svg"
                        alt="Share"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Share
                      </span>
                    )}
                  </div>
                </button>
              </div>
            )} */}
          {meetingSettings && meetingSettings.allowRaiseHand && (
            <div className="relative">
              <button
                onClick={() => {
                  publishRaiseHand("Raise Hand");
                  toast("Raised hand", {
                    position: "bottom-left",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeButton: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Raise"
                aria-label="Raise"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    <img
                      src="/icons/raiseHand.svg"
                      alt="Raise"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Raise
                    </span>
                  )}
                </div>
              </button>
            </div>
          )}

          {meetingSettings && meetingSettings.allowReactions && (
            <div className="relative">
              <button
                onClick={() => {
                  setShowReactions(!showReactions);
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Reactions"
                aria-label="Reactions"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    <img
                      src="/icons/reaction.svg"
                      alt="Reactions"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Reactions
                    </span>
                  )}
                </div>
              </button>
              {showReactions && (
                <div
                  data-reactions-dropdown
                  className="absolute top-full right-0 md:right-auto md:left-0 mt-2 z-50 p-2 md:p-3 rounded-xl md:rounded-2xl shadow-2xl border border-gray-300 bg-white"
                  onMouseDown={(e) => e.stopPropagation()}
                >
                  <div className="grid grid-cols-5 gap-1 md:gap-2 min-w-[180px] md:min-w-[220px]">
                    {emojis.map(({ char, alt }) => (
                      <button
                        key={char}
                        aria-label={alt}
                        title={alt}
                        onClick={() => handleEmojiClick({ char, alt })}
                        className="w-8 h-8 md:w-10 md:h-10 text-lg md:text-2xl rounded-lg md:rounded-xl transition-all duration-200 ease-out bg-white border border-gray-200 hover:bg-gray-50 hover:scale-110 hover:-translate-y-0.5 hover:shadow-lg hover:border-gray-300 active:scale-95 flex items-center justify-center"
                      >
                        {char}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          )}

          {!isMobile &&
            (["moderator", "co-host"].includes(meetingRole) ||
              (meetingSettings && meetingSettings.allowScreenSharing)) && (
              <div className="relative">
                <button
                  onClick={() => {
                    mMeeting.toggleScreenShare();
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title="Share Screen"
                  aria-label="Share Screen"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src={
                          mMeeting.isScreenSharing
                            ? "/icons/shareScreennOn.svg"
                            : "/icons/shareScreenn.svg"
                        }
                        alt="Share Screen"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Share Screen
                      </span>
                    )}
                  </div>
                </button>
              </div>
            )}

          {["moderator", "co-host"].includes(meetingRole) && (
            <div className="relative">
              <button
                onClick={() => {
                  handleRecordingClick();
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Record"
                aria-label="Record"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    <img
                      src={
                        mMeeting.recordingState ==
                          Constants.recordingEvents.RECORDING_STOPPED
                          ? "/icons/recordOff.svg"
                          : "/icons/recordOn.svg"
                      }
                      alt="Record"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Record
                    </span>
                  )}
                </div>
              </button>
            </div>
          )}

          {meetingRole === "moderator" &&
            meetingSettings &&
            meetingSettings.customButtonText &&
            meetingSettings.customButtonUrl && (
              <button
                onClick={() => {
                  window.open(meetingSettings.customButtonUrl, "_blank");
                }}
                className={`p-0 hover:text-white bg-[#7700ff] text-white rounded-md ${compactMode
                  ? "text-xs px-1 py-1 transition-all duration-300 ease-in-out"
                  : "text-sm mx-0.5 lg:mx-1 sm:text-sm px-1 py-1 sm:py-2 transition-all duration-300 ease-in-out"
                  }`}
                title={meetingSettings.customButtonText}
                aria-label={meetingSettings.customButtonText}
              >
                {meetingSettings.customButtonText}
              </button>
            )}
        </div>
      </div>

      {/* Center Section - Meeting Name */}
      <div className="flex-1 flex justify-center items-center w-1/7">
        <div className="bg-gray-800 px-1 sm:px-2 md:px-3 py-1 sm:py-2 rounded-lg flex items-center gap-1 sm:gap-2 max-w-full">
          {/* {showMeetingName && (
            <span className="text-[#7700FF] font-medium text-xs sm:text-sm md:text-base tracking-wide truncate">
              {meetingSettings?.roomName || "Meeting Name"}
            </span>
          )} */}
          {/* Chevron moved into bottom notch */}
          <span className="hidden" />
        </div>
      </div>

      {/* Right Section */}
      <div className="flex items-center flex-shrink-0 w-3/7 relative h-full">
        {/* Mobile Right Section - Participant and Profile */}
        <div
          className={`${isMobileLike ? "flex" : "hidden"} items-center gap-4`}
        >
          {/* Mobile Participant Toggle */}
          <button
            onClick={() => {
              setSideBarMode((s) =>
                s === sideBarModes.PARTICIPANTS
                  ? null
                  : sideBarModes.PARTICIPANTS
              );
            }}
            className="relative flex items-center gap-1 text-white focus:outline-none"
            title="Participants"
            aria-label="Participants"
            type="button"
          >
            <span className="text-sm font-medium">
              {mMeeting?.participants?.size || 0}
            </span>
            <div className="relative">
              {participantApproveFunc?.length > 0 && (
                <span className="absolute -top-1 -right-1 z-10 inline-flex items-center justify-center min-w-[14px] h-3.5 px-1 rounded-full bg-red-500 text-white text-[9px] font-semibold">
                  {participantApproveFunc.length}
                </span>
              )}
              <img
                src="/icons/participants.svg"
                alt="Participants"
                className="w-5"
              />
            </div>
          </button>

          {/* Profile Icon - only show when authenticated */}
          {isAuthenticated && (
            <button
              onClick={() => {
                setShowProfileConfirmModal(true);
              }}
              className={`p-0 text-slate-300 hover:text-white transition-colors duration-200 ${isMobileLike ? "mr-2" : ""
                }`}
              title="Profile"
              aria-label="Profile"
            >
              {user?.logo ? (
                <img
                  alt="Profile"
                  className="w-8 h-8 rounded-full object-cover border border-gray-600 hover:border-gray-400 transition-all duration-200"
                  src={user?.logo}
                />
              ) : (
                <img
                  alt="Profile"
                  className="rounded-full object-cover w-8 h-8 hover:opacity-80 transition-opacity duration-200"
                  src="/icons/profile.svg"
                />
              )}
            </button>
          )}

          {/* Hamburger Icon */}
          {isMobile && isMobileLandscape && (
            <button
              onClick={() => {
                if (isAuthenticated) {
                  setShowMobilePanel(!showMobilePanel);
                }
              }}
              className={`p-0 text-slate-300 hover:text-white transition-colors duration-200 ${isMobileLike ? "mr-2" : ""
                }`}
              title="Hamburger"
              aria-label="Hamburger"
            >
              <img
                src="/icons/hamburger.svg"
                alt="Hamburger"
                className=" object-cover  hover:border-gray-400 transition-all duration-200"
              />
            </button>
          )}
        </div>

        {!isMobileLike && (
          <div
            className={`hidden lg:flex items-center justify-center transition-all duration-300 ease-in-out h-full relative ${compactMode
              ? "gap-2 lg:gap-2.5 xl:gap-3 2xl:gap-4"
              : "gap-1.5 lg:gap-2 xl:gap-2.5 2xl:gap-3"
              }`}
          >
            {["moderator", "co-host"].includes(meetingRole) && (
              <div className="relative">
                <button
                  onClick={() => {
                    setLeftSideBarMode(
                      leftSideBarMode === "ELEMENTS" ? null : "ELEMENTS"
                    );
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title="Elements"
                  aria-label="Elements"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/elements.svg"
                        alt="Elements"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Elements
                      </span>
                    )}
                  </div>
                </button>
              </div>
            )}
            {meetingSettings && meetingSettings.allowChat && (
              <div className="relative">
                <button
                  onClick={() => {
                    setSideBarMode((s) =>
                      s === sideBarModes.CHAT ? null : sideBarModes.CHAT
                    );
                    setUnreadChat(false);
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title="Chat"
                  aria-label="Chat"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/chat.svg"
                        alt="Chat"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Chat
                      </span>
                    )}
                    {unreadChat && (
                      <span className="absolute -top-0 right-1 text-blue-500 text-xs font-semibold flex items-center justify-center shadow-sm">
                        <span className="w-2 h-2 rounded-full bg-red-500"></span>
                      </span>
                    )}
                  </div>
                </button>
              </div>
            )}
            <div className="relative">
              <button
                onClick={() => {
                  setSideBarMode((s) =>
                    s === sideBarModes.PARTICIPANTS
                      ? null
                      : sideBarModes.PARTICIPANTS
                  );
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Participants"
                aria-label="Participants"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="relative flex items-center justify-center gap-1">
                    <div className="relative flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      {participantApproveFunc?.length > 0 && (
                        <span className="absolute -top-0.5 -right-0.5 z-10 inline-flex items-center justify-center min-w-[14px] h-3.5 px-1 rounded-full bg-red-500 text-white text-[9px] font-semibold shadow-sm">
                          {participantApproveFunc.length}
                        </span>
                      )}
                      <img
                        src="/icons/participants.svg"
                        alt="Participants"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {mMeeting &&
                      mMeeting.participants &&
                      mMeeting.participants.size && (
                        <span
                          className={`text-white text-[10px] sm:text-xs font-medium ${participantApproveFunc?.length > 0 ? "ml-0.5" : ""
                            }`}
                        >
                          {mMeeting.participants.size}
                        </span>
                      )}
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Participants
                    </span>
                  )}
                </div>
              </button>
            </div>

            <div className="relative h-full">
              <button
                onClick={() => {
                  console.log("showToolsDropdown", showToolsDropdown);
                  setShowToolsDropdown(!showToolsDropdown);
                  setShowCaptionsDropdown(false);
                  setShowLayoutDropdown(false);
                  setShowVideoDropdown(false);
                  setShowAudioInputDropdown(false);
                  setShowMore(false);
                }}
                className="h-full flex items-center px-2 text-slate-300 hover:text-white"
                title="Tools"
                aria-label="Tools"
              >
                <div className="h-full flex items-center gap-1.5 transition-all duration-300 ease-in-out min-w-fit relative">
                  {/* Icon and Label Container */}
                  <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/tools.svg"
                        alt="Tools"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Tools
                      </span>
                    )}
                  </div>

                  {/* Chevron - Right side, vertically centered */}
                  <div className="flex items-center justify-center opacity-100 transition-all duration-300 ease-in-out">
                    <img
                      src="/icons/chevronDown.svg"
                      alt="dropdown"
                      className={`cursor-pointer transition-transform duration-200 ${showToolsDropdown ? "rotate-180" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowToolsDropdown(!showToolsDropdown);
                        setShowCaptionsDropdown(false);
                        setShowLayoutDropdown(false);
                        setShowVideoDropdown(false);
                        setShowAudioInputDropdown(false);
                        setShowMore(false);
                      }}
                      title="Tools Settings"
                      draggable={false}
                    />
                  </div>
                </div>
              </button>

              {/* Tools Options */}
              {showToolsDropdown && (
                <ToolsDropdown
                  meetingRole={meetingRole}
                  startWhiteboard={startWhiteboard}
                  isLiveStreaming={isLiveStreaming}
                  handleStopLiveStream={handleStopLiveStream}
                  setShowLiveStreamModal={setShowLiveStreamModal}
                  setShowToolsDropdown={setShowToolsDropdown}
                  showCaptionsDropdown={showCaptionsDropdown}
                  setShowCaptionsDropdown={setShowCaptionsDropdown}
                  setShowPollsModal={setShowPollsModal}
                  setShowLayoutDropdown={setShowLayoutDropdown}
                  setShowVideoDropdown={setShowVideoDropdown}
                  setShowAudioInputDropdown={setShowAudioInputDropdown}
                  user={user}
                  mMeeting={mMeeting}
                  isMobile={isMobile}
                  meetingSettings={meetingSettings}
                  translationEnabled={translationEnabled}
                  setTranslationEnabled={setTranslationEnabled}
                  translationStatus={translationStatus}
                  startTranslation={startTranslation}
                  changeTranslationLanguage={changeTranslationLanguage}
                  selectedLanguage={selectedLanguage}
                  setSelectedLanguage={setSelectedLanguage}
                  showLiveStreamModal={showLiveStreamModal}
                  liveStreamPlatforms={liveStreamPlatforms}
                  setLiveStreamPlatforms={setLiveStreamPlatforms}
                  streamingCredentials={streamingCredentials}
                  setStreamingCredentials={setStreamingCredentials}
                  handleStartLiveStream={handleStartLiveStream}
                  startTranscription={startTranscription}
                  stopTranscription={stopTranscription}
                  transcriptionEnabled={transcriptionEnabled}
                  setTranscriptionEnabled={setTranscriptionEnabled}
                  showBreakoutRoomsModal={showBreakoutRoomsModal}
                  setShowBreakoutRoomsModal={setShowBreakoutRoomsModal}
                />
              )}
            </div>

            <div className="relative h-full">
              <button
                onClick={() => {
                  setShowLayoutDropdown(!showLayoutDropdown);
                  setShowMicDropdown(false);
                  setShowVideoDropdown(false);
                  setShowSpeakerDropdown(false);
                  setShowCaptionsDropdown(false);
                  setShowToolsDropdown(false);
                  setShowMore(false);
                }}
                className="h-full flex items-center px-2 text-slate-300 hover:text-white"
                title="Layout"
                aria-label="Layout"
              >
                <div className="h-full flex items-center gap-1.5 transition-all duration-300 ease-in-out min-w-fit relative">
                  {/* Icon and Label Container */}
                  <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/layout.svg"
                        alt="Layout"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Layout
                      </span>
                    )}
                  </div>

                  {/* Chevron - Right side, vertically centered */}
                  <div className="flex items-center justify-center opacity-100 transition-all duration-300 ease-in-out">
                    <img
                      src="/icons/chevronDown.svg"
                      alt="dropdown"
                      className={`cursor-pointer transition-transform duration-200 ${showLayoutDropdown ? "rotate-180" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowLayoutDropdown(!showLayoutDropdown);
                        setShowMicDropdown(false);
                        setShowVideoDropdown(false);
                        setShowSpeakerDropdown(false);
                        setShowCaptionsDropdown(false);
                        setShowToolsDropdown(false);
                        setShowMore(false);
                      }}
                      title="Layout Settings"
                      draggable={false}
                    />
                  </div>
                </div>
              </button>

              {/* Layout Dropdown */}
              {showLayoutDropdown && (
                <div
                  data-layout-dropdown
                  className={`absolute top-full right-0 mt-2 w-80 bg-[#060621] rounded-lg shadow-xl border border-gray-600 z-50 py-3 px-4 transition-all duration-300 ease-in-out`}
                >
                  {/* VIEW Section */}
                  <div className="px-4 py-2">
                    <div className="text-white text-center text-sm tracking-widest font-medium mb-5">
                      VIEW
                    </div>

                    {/* Layout Options */}
                    <div className="grid grid-cols-2 gap-3">
                      {/* Gallery Layout */}
                      <button
                        onClick={() => {
                          setSelectedLayout("gallery");
                          setShowLayoutDropdown(false);
                        }}
                        className={`p-3 rounded-lg border transition-colors ${selectedLayout === "gallery"
                          ? "border-[#7700ff] bg-[#7700ff]/10"
                          : "border-gray-600 hover:border-gray-500"
                          }`}
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div className="">
                            <img
                              src="/icons/gallery.svg"
                              alt="gallery"
                              className="w-full h-full object-contain"
                            />
                          </div>
                          <span className="text-white text-xs">Gallery</span>
                        </div>
                      </button>

                      {/* Speaker Top Layout */}
                      <button
                        onClick={() => {
                          setSelectedLayout("speaker-top");
                          setShowLayoutDropdown(false);
                        }}
                        className={`p-3 rounded-lg border transition-colors ${selectedLayout === "speaker-top"
                          ? "border-[#7700ff] bg-[#7700ff]/10"
                          : "border-gray-600 hover:border-gray-500"
                          }`}
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div className="">
                            <img
                              src="/icons/speakerTop.svg"
                              alt="speakerTop"
                              className="w-full h-full object-contain"
                            />
                          </div>
                          <span className="text-white text-xs">
                            Speaker Top
                          </span>
                        </div>
                      </button>

                      {/* Focus Layout */}
                      <button
                        onClick={() => {
                          setSelectedLayout("focus");
                          setShowLayoutDropdown(false);
                        }}
                        className={`p-3 rounded-lg border transition-colors ${selectedLayout === "focus"
                          ? "border-[#7700ff] bg-[#7700ff]/10"
                          : "border-gray-600 hover:border-gray-500"
                          }`}
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div className="">
                            <img
                              src="/icons/speakerFocus.svg"
                              alt="focus"
                              className="w-full h-full object-contain"
                            />
                          </div>
                          <span className="text-white text-xs">Focus</span>
                        </div>
                      </button>

                      {/* Speaker Side Layout */}
                      <button
                        onClick={() => {
                          setSelectedLayout("speaker-side");
                          setShowLayoutDropdown(false);
                        }}
                        className={`p-3 rounded-lg border transition-colors ${selectedLayout === "speaker-side"
                          ? "border-[#7700ff] bg-[#7700ff]/10"
                          : "border-gray-600 hover:border-gray-500"
                          }`}
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div className="">
                            <img
                              src="/icons/speakerSide.svg"
                              alt="speakerSide"
                              className="w-full h-full object-contain"
                            />
                          </div>
                          <span className="text-white text-xs">
                            Speaker Side
                          </span>
                        </div>
                      </button>
                    </div>
                  </div>

                  {/* Separator */}
                  <div className="border-t border-gray-600 my-4"></div>

                  {/* OPTIONS Section */}
                  <div className="px-4 py-2">
                    <div className="text-white text-center text-sm tracking-widest font-medium mb-3">
                      OPTIONS
                    </div>

                    <div className="space-y-2">
                      {/* Fullscreen Option */}
                      <button
                        onClick={() => {
                          setIsFullscreen(!isFullscreen);
                          setShowLayoutDropdown(false);
                          handleToggleFullscreen();
                        }}
                        className={`w-full text-left px-3 py-2 text-sm ${!isFullscreen
                          ? "text-gray-400 hover:text-white"
                          : "text-white hover:bg-white/10 transition-colors"
                          }`}
                      >
                        Fullscreen
                      </button>

                      {/* Hide self view Option */}
                      {mMeeting &&
                        mMeeting.participants &&
                        Array.from(mMeeting.participants.keys()).length > 1 && (
                          <button
                            onClick={() => {
                              setHideSelfView(!hideSelfView);
                              setShowLayoutDropdown(false);
                            }}
                            className={`w-full text-left px-3 py-2 text-sm ${hideSelfView ? "text-white" : "text-gray-400"
                              }`}
                          >
                            Hide self view
                          </button>
                        )}

                      {/* Show non-video participants Option */}
                      {selectedLayout == "gallery" && (
                        <button
                          onClick={() => {
                            setShowNonVideoParticipants(
                              !showNonVideoParticipants
                            );
                            setShowLayoutDropdown(false);
                          }}
                          className={`w-full text-left px-3 py-2 text-sm ${showNonVideoParticipants
                            ? "text-white"
                            : "text-gray-400"
                            }`}
                        >
                          Show non-video participants
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="relative">
              <button
                onClick={() => {
                  setShowMore(!showMore);
                  setShowLayoutDropdown(false);
                  setShowMicDropdown(false);
                  setShowVideoDropdown(false);
                  setShowSpeakerDropdown(false);
                  setShowCaptionsDropdown(false);
                  setShowToolsDropdown(false);
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Settings"
                aria-label="Settings"
              >
                <div className="h-full flex items-center gap-1.5 transition-all duration-300 ease-in-out min-w-fit relative">
                  {/* Icon and Label Container */}
                  <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                      <img
                        src="/icons/settings.svg"
                        alt="Settings"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Settings
                      </span>
                    )}
                  </div>

                  {/* Chevron - Right side, vertically centered */}
                  <div className="flex items-center justify-center opacity-100 transition-all duration-300 ease-in-out">
                    <img
                      src="/icons/chevronDown.svg"
                      alt="dropdown"
                      className={`cursor-pointer transition-transform duration-200 ${showMore ? "rotate-180" : ""
                        }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowMore(!showMore);
                        setShowMicDropdown(false);
                        setShowVideoDropdown(false);
                        setShowSpeakerDropdown(false);
                        setShowCaptionsDropdown(false);
                        setShowToolsDropdown(false);
                      }}
                      title="Settings"
                      draggable={false}
                    />
                  </div>
                </div>
              </button>
            </div>

            <div className="relative">
              <button
                onClick={handleLeaveModal}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Logout"
                aria-label="Logout"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-5 lg:h-5">
                    <img
                      src="/icons/logout.svg"
                      alt="Logout"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Logout
                    </span>
                  )}
                </div>
              </button>
            </div>

            {/* Profile Icon - only show when authenticated */}
            {isAuthenticated && (
              <div className="relative">
                <button
                  onClick={() => {
                    setShowProfileConfirmModal(true);
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title="Profile"
                  aria-label="Profile"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center ">
                      <img
                        src={user?.logo ? user.logo : "/icons/profile.svg"}
                        alt="Profile"
                        className="object-cover rounded-full object-cover w-6 h-6 hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Profile
                      </span>
                    )}
                  </div>
                </button>
              </div>
            )}
          </div>
        )}

        {/* Small Desktop Screen - Show minimal icons */}
        {!isMobileLike && (
          <div className="hidden sm:flex md:hidden items-center gap-1.5">
            {meetingSettings && meetingSettings.allowChat && (
              <div className="relative">
                <button
                  onClick={() => {
                    setSideBarMode((s) =>
                      s === sideBarModes.CHAT ? null : sideBarModes.CHAT
                    );
                    setUnreadChat(false);
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title="Chat"
                  aria-label="Chat"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit h-6 sm:h-8">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                      <img
                        src="/icons/chat.svg"
                        alt="Chat"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                  </div>
                </button>
                {unreadChat && (
                  <div className="pointer-events-none absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full z-20"></div>
                )}
              </div>
            )}

            <div className="relative">
              <button
                onClick={() => {
                  setSideBarMode((s) =>
                    s === sideBarModes.PARTICIPANTS
                      ? null
                      : sideBarModes.PARTICIPANTS
                  );
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Participants"
                aria-label="Participants"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit h-6 sm:h-8">
                  <div className="relative flex items-center justify-center gap-1">
                    <div className="relative flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                      {participantApproveFunc?.length > 0 && (
                        <span className="absolute -top-0.5 -right-1 z-10 inline-flex items-center justify-center min-w-[14px] h-3.5 px-1 rounded-full bg-red-500 text-white text-[8px] font-semibold shadow-sm">
                          {participantApproveFunc.length}
                        </span>
                      )}
                      <img
                        src="/icons/participants.svg"
                        alt="Participants"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {mMeeting &&
                      mMeeting.participants &&
                      mMeeting.participants.size && (
                        <span
                          className={`text-[#7F7F7F] text-[10px] sm:text-xs font-medium ${participantApproveFunc?.length > 0 ? "ml-0.5" : ""
                            }`}
                        >
                          {mMeeting.participants.size}
                        </span>
                      )}
                  </div>
                </div>
              </button>
            </div>

            <div className="relative">
              <button
                onClick={() => {
                  setShowMore(!showMore);
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Settings"
                aria-label="Settings"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit h-6 sm:h-8">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                    <img
                      src="/icons/settings.svg"
                      alt="Settings"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                </div>
              </button>
            </div>

            <div className="relative">
              <button
                onClick={() => {
                  setShowMore(!showMore);
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Settings"
                aria-label="Settings"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit h-6 sm:h-8">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                    <img
                      src="/icons/settings.svg"
                      alt="Settings"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                </div>
              </button>
            </div>

            <div className="relative">
              <button
                onClick={handleLeaveModal}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Logout"
                aria-label="Logout"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit h-6 sm:h-8">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                    <img
                      src="/icons/logout.svg"
                      alt="Logout"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                </div>
              </button>
            </div>

            {/* Profile Icon - only show when authenticated */}
            {isAuthenticated && (
              <div className="relative">
                <button
                  onClick={() => {
                    setShowProfileConfirmModal(true);
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200 hover:scale-105"
                  title="Profile"
                  aria-label="Profile"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit h-6 sm:h-8">
                    <div className="flex items-center justify-center w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 lg:w-7 lg:h-7 xl:w-8 xl:h-8">
                      <img
                        src={user?.logo ? user.logo : "/icons/profile.svg"}
                        alt="Profile"
                        className="rounded-full object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                  </div>
                </button>
              </div>
            )}
          </div>
        )}

        {/* Medium Desktop Screen - Show fewer icons */}
        {!isMobileLike && (
          <div className="hidden md:flex lg:hidden items-center gap-1.5 xl:gap-2">
            {meetingSettings && meetingSettings.allowChat && (
              <div className="relative">
                <button
                  onClick={() => {
                    setSideBarMode((s) =>
                      s === sideBarModes.CHAT ? null : sideBarModes.CHAT
                    );
                    setUnreadChat(false);
                  }}
                  className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                  title="Chat"
                  aria-label="Chat"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                      <img
                        src="/icons/chat.svg"
                        alt="Chat"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <div className="flex flex-col items-center justify-center h-6 opacity-100 transition-all duration-300 ease-in-out">
                        <span className="select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                          Chat
                        </span>
                      </div>
                    )}
                  </div>
                </button>
                {unreadChat && (
                  <div className="pointer-events-none absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full z-20"></div>
                )}
              </div>
            )}

            <div className="relative">
              <button
                onClick={() => {
                  setShowToolsDropdown(!showToolsDropdown);
                  setShowCaptionsDropdown(false);
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Tools"
                aria-label="Tools"
              >
                <div className="h-full flex items-center gap-1.5 transition-all duration-300 ease-in-out min-w-fit relative">
                  {/* Icon and Label Container */}
                  <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                      <img
                        src="/icons/tools.svg"
                        alt="Tools"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <div className="flex flex-col items-center justify-center h-6 opacity-100 transition-all duration-300 ease-in-out">
                        <span className="select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                          Tools
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Chevron - Right side, vertically centered */}
                  {!compactMode && (
                    <div className="flex items-center justify-center opacity-100 transition-all duration-300 ease-in-out">
                      <img
                        src="/icons/chevronDown.svg"
                        alt="dropdown"
                        className={`transition-transform duration-200 ${showToolsDropdown ? "rotate-180" : ""
                          }`}
                      />
                    </div>
                  )}
                </div>
              </button>

              {/* Tools Options */}
              {showToolsDropdown && (
                <ToolsDropdown
                  meetingRole={meetingRole}
                  startWhiteboard={startWhiteboard}
                  isLiveStreaming={isLiveStreaming}
                  handleStopLiveStream={handleStopLiveStream}
                  setShowLiveStreamModal={setShowLiveStreamModal}
                  setShowToolsDropdown={setShowToolsDropdown}
                  showCaptionsDropdown={showCaptionsDropdown}
                  setShowCaptionsDropdown={setShowCaptionsDropdown}
                  setShowPollsModal={setShowPollsModal}
                  setShowLayoutDropdown={setShowLayoutDropdown}
                  setShowVideoDropdown={setShowVideoDropdown}
                  setShowAudioInputDropdown={setShowAudioInputDropdown}
                  user={user}
                  mMeeting={mMeeting}
                  isMobile={isMobile}
                  meetingSettings={meetingSettings}
                  translationEnabled={translationEnabled}
                  setTranslationEnabled={setTranslationEnabled}
                  translationStatus={translationStatus}
                  startTranslation={startTranslation}
                  changeTranslationLanguage={changeTranslationLanguage}
                  selectedLanguage={selectedLanguage}
                  setSelectedLanguage={setSelectedLanguage}
                  showLiveStreamModal={showLiveStreamModal}
                  liveStreamPlatforms={liveStreamPlatforms}
                  setLiveStreamPlatforms={setLiveStreamPlatforms}
                  streamingCredentials={streamingCredentials}
                  setStreamingCredentials={setStreamingCredentials}
                  handleStartLiveStream={handleStartLiveStream}
                  startTranscription={startTranscription}
                  stopTranscription={stopTranscription}
                  transcriptionEnabled={transcriptionEnabled}
                  setTranscriptionEnabled={setTranscriptionEnabled}
                />
              )}
            </div>

            <div className="relative">
              <button
                onClick={() => {
                  setSideBarMode((s) =>
                    s === sideBarModes.PARTICIPANTS
                      ? null
                      : sideBarModes.PARTICIPANTS
                  );
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Participants"
                aria-label="Participants"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="relative flex items-center justify-center gap-1">
                    <div className="relative flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                      {participantApproveFunc?.length > 0 && (
                        <span className="absolute -top-0.5 -right-0.5 z-10 inline-flex items-center justify-center min-w-[14px] h-3.5 px-1 rounded-full bg-red-500 text-white text-[9px] font-semibold shadow-sm">
                          {participantApproveFunc.length}
                        </span>
                      )}
                      <img
                        src="/icons/participants.svg"
                        alt="Participants"
                        className="object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {mMeeting &&
                      mMeeting.participants &&
                      mMeeting.participants.size && (
                        <span
                          className={`text-[#7F7F7F] text-[10px] sm:text-xs font-medium ${participantApproveFunc?.length > 0 ? "ml-0.5" : ""
                            }`}
                        >
                          {mMeeting.participants.size}
                        </span>
                      )}
                  </div>
                  {!compactMode && (
                    <div className="flex flex-col items-center justify-center h-6 opacity-100 transition-all duration-300 ease-in-out">
                      <span className="select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Participants
                      </span>
                    </div>
                  )}
                </div>
              </button>
            </div>

            <div className="relative">
              <button
                onClick={() => {
                  setShowMore(!showMore);
                }}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Settings"
                aria-label="Settings"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                    <img
                      src="/icons/settings.svg"
                      alt="Settings"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Settings
                    </span>
                  )}
                </div>
              </button>
            </div>

            <div className="relative">
              <button
                onClick={handleLeaveModal}
                className="px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200"
                title="Logout"
                aria-label="Logout"
              >
                <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                  <div className="flex items-center justify-center w-2.5 h-2.5 sm:w-3 sm:h-3 md:w-3.5 md:h-3.5 lg:w-4 lg:h-4">
                    <img
                      src="/icons/logout.svg"
                      alt="Logout"
                      className="object-contain hover:opacity-80 transition-all duration-200"
                      draggable={false}
                    />
                  </div>
                  {!compactMode && (
                    <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                      Logout
                    </span>
                  )}
                </div>
              </button>
            </div>

            {/* Profile Icon - Now visible on medium screens, only when authenticated */}
            {isAuthenticated && (
              <div className="relative">
                <button
                  onClick={() => {
                    setShowProfileConfirmModal(true);
                  }}
                  className={`px-0.5 sm:px-1 md:px-2 lg:px-3 text-slate-300 h-full hover:text-white flex items-center justify-center transition-all duration-200 hover:scale-105`}
                  title="Profile"
                  aria-label="Profile"
                >
                  <div className="flex flex-col items-center justify-center transition-all duration-300 ease-in-out min-w-fit">
                    <div
                      className={`flex items-center justify-center ${compactMode
                        ? "w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6 lg:w-7 lg:h-7 xl:w-8 xl:h-8"
                        : "w-4 h-4 md:w-7 md:h-7"
                        }`}
                    >
                      <img
                        src={user?.logo ? user.logo : "/icons/profile.svg"}
                        alt="Profile"
                        className="rounded-full object-contain hover:opacity-80 transition-all duration-200"
                        draggable={false}
                      />
                    </div>
                    {!compactMode && (
                      <span className="mt-1 duration-300 ease-in-out transition-all select-none text-[8px] sm:text-[10px] text-[#E0E0E0] whitespace-nowrap">
                        Profile
                      </span>
                    )}
                  </div>
                </button>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Mobile Bottom Bar */}
      <MobileBottomBar
        isMobileLike={isMobileLike}
        isMobileLandscape={isMobileLandscape}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        setShowMobilePanel={setShowMobilePanel}
        localMicOn={localMicOn}
        handleToggleMic={handleToggleMic}
        isTogglingMic={isTogglingMic}
        handleToggleWebcam={handleToggleWebcam}
        isTogglingWebcam={isTogglingWebcam}
        showMicDropdown={showMicDropdown}
        mics={mics}
        selectedMic={selectedMic}
        changeMic={changeMic}
        showAudioInputDropdown={showAudioInputDropdown}
        setShowAudioInputDropdown={setShowAudioInputDropdown}
        speakers={speakers}
        selectedSpeaker={selectedSpeaker}
        setSelectedSpeaker={setSelectedSpeaker}
        showSpeakerDropdown={showSpeakerDropdown}
        setShowSpeakerDropdown={setShowSpeakerDropdown}
        getMics={getMics}
        setShowMicDropdown={setShowMicDropdown}
        localWebcamOn={localWebcamOn}
        mMeeting={mMeeting}
        showVideoDropdown={showVideoDropdown}
        webcams={webcams}
        selectedWebcam={selectedWebcam}
        changeWebcam={changeWebcam}
        showVideoSourceDropdown={showVideoSourceDropdown}
        setShowVideoSourceDropdown={setShowVideoSourceDropdown}
        setShowVirtualBackgroundModal={setShowVirtualBackgroundModal}
        getWebcams={getWebcams}
        setShowVideoDropdown={setShowVideoDropdown}
        setSideBarMode={setSideBarMode}
        unreadChat={unreadChat}
        setUnreadChat={setUnreadChat}
        setShowHelpModal={setShowHelpModal}
        handleLeaveModal={handleLeaveModal}
      />

      {/* Mobile Live Stream Modal */}
      {isMobileLike && showLiveStreamModal && (
        <div className="fixed inset-0 z-50">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowLiveStreamModal(false)}
          />
          <div className="absolute left-0 right-0 bg-[#060621] border-t border-gray-700 rounded-t-2xl p-5 text-white max-h-[80vh] overflow-y-auto bottom-20">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <img
                  src="/icons/livestream.svg"
                  alt="Livestream"
                  className="w-5 h-5"
                />
                <h3 className="text-base font-medium">Livestream</h3>
              </div>
              <button
                onClick={() => setShowLiveStreamModal(false)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <div className="h-px bg-gray-700 mb-4" />
            <div className="text-center text-xs tracking-widest text-gray-300 uppercase mb-3">
              Select your platform
            </div>

            <div className="space-y-4">
              {/* YouTube */}
              <div className="space-y-2 pb-3 border-b border-gray-700">
                <div className="flex items-center justify-start p-1">
                  <label className="relative inline-flex items-center cursor-pointer mr-4">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={liveStreamPlatforms.youtube}
                      onChange={(e) =>
                        setLiveStreamPlatforms((prev) => ({
                          ...prev,
                          youtube: e.target.checked,
                        }))
                      }
                    />
                    <div className="w-9 h-5 bg-gray-600 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-red-600"></div>
                  </label>
                  <div className="flex items-center gap-2">
                    <img
                      src="/icons/yt.svg"
                      alt="YouTube"
                      className="w-7 h-7"
                    />
                    <div className="font-medium">YouTube</div>
                  </div>
                </div>
                <div
                  className={`${liveStreamPlatforms.youtube
                    ? "opacity-100 max-h-40"
                    : "opacity-0 max-h-0 pointer-events-none"
                    } transition-all duration-300 ease-out pl-12 space-y-2 overflow-hidden`}
                >
                  <input
                    type="text"
                    placeholder="Stream URL"
                    value={streamingCredentials.youtube.url}
                    onChange={(e) =>
                      setStreamingCredentials((prev) => ({
                        ...prev,
                        youtube: { ...prev.youtube, url: e.target.value },
                      }))
                    }
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-red-600"
                  />
                  <input
                    type="text"
                    placeholder="Stream Key"
                    value={streamingCredentials.youtube.key}
                    onChange={(e) =>
                      setStreamingCredentials((prev) => ({
                        ...prev,
                        youtube: { ...prev.youtube, key: e.target.value },
                      }))
                    }
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-red-600"
                  />
                </div>
              </div>

              {/* Facebook */}
              <div className="space-y-2 pb-3 border-b border-gray-700">
                <div className="flex items-center justify-start p-1">
                  <label className="relative inline-flex items-center cursor-pointer mr-4">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={liveStreamPlatforms.facebook}
                      onChange={(e) =>
                        setLiveStreamPlatforms((prev) => ({
                          ...prev,
                          facebook: e.target.checked,
                        }))
                      }
                    />
                    <div className="w-9 h-5 bg-gray-600 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-600"></div>
                  </label>
                  <div className="flex items-center gap-2">
                    <img
                      src="/icons/fb.svg"
                      alt="Facebook"
                      className="w-7 h-7"
                    />
                    <div className="font-medium">Facebook</div>
                  </div>
                </div>
                <div
                  className={`${liveStreamPlatforms.facebook
                    ? "opacity-100 max-h-40"
                    : "opacity-0 max-h-0 pointer-events-none"
                    } transition-all duration-300 ease-out pl-12 space-y-2 overflow-hidden`}
                >
                  <input
                    type="text"
                    placeholder="Stream URL"
                    value={streamingCredentials.facebook.url}
                    onChange={(e) =>
                      setStreamingCredentials((prev) => ({
                        ...prev,
                        facebook: { ...prev.facebook, url: e.target.value },
                      }))
                    }
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-600"
                  />
                  <input
                    type="text"
                    placeholder="Stream Key"
                    value={streamingCredentials.facebook.key}
                    onChange={(e) =>
                      setStreamingCredentials((prev) => ({
                        ...prev,
                        facebook: { ...prev.facebook, key: e.target.value },
                      }))
                    }
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-600"
                  />
                </div>
              </div>

              {/* LinkedIn */}
              <div className="space-y-2">
                <div className="flex items-center justify-start p-1">
                  <label className="relative inline-flex items-center cursor-pointer mr-4">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      checked={liveStreamPlatforms.linkedin}
                      onChange={(e) =>
                        setLiveStreamPlatforms((prev) => ({
                          ...prev,
                          linkedin: e.target.checked,
                        }))
                      }
                    />
                    <div className="w-9 h-5 bg-gray-600 rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-blue-700"></div>
                  </label>
                  <div className="flex items-center gap-2">
                    <img
                      src="/icons/linkedin.svg"
                      alt="LinkedIn"
                      className="w-7 h-7"
                    />
                    <div className="font-medium">LinkedIn</div>
                  </div>
                </div>
                <div
                  className={`${liveStreamPlatforms.linkedin
                    ? "opacity-100 max-h-40"
                    : "opacity-0 max-h-0 pointer-events-none"
                    } transition-all duration-300 ease-out pl-12 space-y-2 overflow-hidden`}
                >
                  <input
                    type="text"
                    placeholder="Stream URL"
                    value={streamingCredentials.linkedin.url}
                    onChange={(e) =>
                      setStreamingCredentials((prev) => ({
                        ...prev,
                        linkedin: { ...prev.linkedin, url: e.target.value },
                      }))
                    }
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-700"
                  />
                  <input
                    type="text"
                    placeholder="Stream Key"
                    value={streamingCredentials.linkedin.key}
                    onChange={(e) =>
                      setStreamingCredentials((prev) => ({
                        ...prev,
                        linkedin: { ...prev.linkedin, key: e.target.value },
                      }))
                    }
                    className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded text-white text-sm focus:outline-none focus:border-blue-700"
                  />
                </div>
              </div>
            </div>

            {/* Actions */}
            <div className="flex gap-3 mt-5">
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-transparent border border-white text-white hover:bg-white/10"
                onClick={() => setShowLiveStreamModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-transparent border border-[#00C853] text-[#00C853] hover:bg-white/10"
                onClick={() => handleStartLiveStream(liveStreamPlatforms)}
              >
                Go Live
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Swipe-Up Panel */}
      <MobileSwipeUpPanel
        showMobilePanel={showMobilePanel}
        isMobileLike={isMobileLike}
        isMobileLandscape={isMobileLandscape}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        setShowMobilePanel={setShowMobilePanel}
        setShowCaptionsDropdown={setShowCaptionsDropdown}
        showCaptionsDropdown={showCaptionsDropdown}
        setShowReactions={setShowReactions}
        showReactions={showReactions}
        setShowToolsDropdown={setShowToolsDropdown}
        setShowLayoutDropdown={setShowLayoutDropdown}
        showLayoutDropdown={showLayoutDropdown}
        meetingRole={meetingRole}
        mMeeting={mMeeting}
        handleRecordingClick={handleRecordingClick}
        meetingSettings={meetingSettings}
        publishRaiseHand={publishRaiseHand}
        showMore={showMore}
        setShowMore={setShowMore}
        setShowHelpModal={setShowHelpModal}
        translationEnabled={translationEnabled}
        setTranslationEnabled={setTranslationEnabled}
        stopTranslation={stopTranslation}
        startTranslation={startTranslation}
        selectedLanguage={selectedLanguage}
        changeTranslationLanguage={changeTranslationLanguage}
        setSelectedLanguage={setSelectedLanguage}
        showElementSection={showElementSection}
        setShowElementSection={setShowElementSection}
        setShowPollsModal={setShowPollsModal}
        handleEmojiClick={handleEmojiClick}
        // Live stream controls for mobile panel
        setShowLiveStreamModal={setShowLiveStreamModal}
        isLiveStreaming={isLiveStreaming}
        handleStopLiveStream={handleStopLiveStream}
        setShowCaptionTranslationPanel={setShowCaptionTranslationPanel}
        // Layout controls
        selectedLayout={selectedLayout}
        setSelectedLayout={setSelectedLayout}
        hideSelfView={hideSelfView}
        setHideSelfView={setHideSelfView}
        showNonVideoParticipants={showNonVideoParticipants}
        setShowNonVideoParticipants={setShowNonVideoParticipants}
        handleToggleFullscreen={handleToggleFullscreen}
        isFullscreen={isFullscreen}
      />

      {/* Help & Support Modal */}
      {showHelpModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowHelpModal(false)}
          />
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-lg mx-4 text-white shadow-2xl">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-xl font-bold uppercase tracking-widest">
                Share Feedback
              </h3>
              <button
                onClick={() => setShowHelpModal(false)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="space-y-4">
              {/* <div>
                <p className="text-xs font-semibold text-gray-400 uppercase mb-1 tracking-widest">
                  Meeting ID
                </p>
                <div className="bg-[#1a1a2e] border border-gray-700 rounded-lg px-3 py-2 text-sm break-all">
                  {mMeeting?.meetingId || "Not available"}
                </div>
              </div>

              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase mb-1 tracking-widest">
                  Session ID
                </p>
                <div className="bg-[#1a1a2e] border border-gray-700 rounded-lg px-3 py-2 text-sm break-all">
                  {resolvedSessionId}
                </div>
              </div> */}

              <div>
                <p className="text-xs font-semibold text-gray-400 uppercase mb-1 tracking-widest">
                  Please Share Your Feedback
                </p>
                <textarea
                  value={helpIssueText}
                  onChange={(e) => setHelpIssueText(e.target.value)}
                  placeholder="Tell us what your experience was.."
                  className="w-full h-28 resize-none bg-[#1a1a2e] border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:border-[#7700ff]"
                />
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-end mt-6">
              <button
                className="w-full sm:w-1/2 px-4 py-2 rounded-lg border border-gray-600 text-gray-200 hover:bg-white/10 transition-colors"
                onClick={() => {
                  setShowHelpModal(false);
                  setHelpIssueText("");
                }}
              >
                Cancel
              </button>
              <button
                className="w-full sm:w-1/2 px-4 py-2 rounded-lg bg-[#7700ff] hover:bg-[#6a00e6] transition-colors text-white"
                onClick={handleHelpSubmit}
              >
                Submit Feedback
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Settings Panel - Single render for all screen sizes */}
      <SettingsPanel
        show={showMore}
        compactMode={compactMode}
        isMobileLike={isMobileLike}
        setShowHelpModal={setShowHelpModal}
        setShowMore={setShowMore}
        handleToggleFullscreen={handleToggleFullscreen}
        handleCopyRoomLink={handleCopyRoomLink}
        user={user}
        TranscriptionToggleRow={TranscriptionToggleRow}
        WaitingRoomToggleRow={WaitingRoomToggleRow}
        GuestCanUnmuteToggleRow={GuestCanUnmuteToggleRow}
        ApprovalSoundToggleRow={ApprovalSoundToggleRow}
        AINoiseRemovalToggleRow={AINoiseRemovalToggleRow}
        meetingRole={meetingRole}
      />

      {/* Caption Translation Panel - Similar to Settings Panel */}
      <CaptionTranslationPanel
        show={showCaptionTranslationPanel}
        isMobileLike={isMobileLike}
        setShowCaptionTranslationPanel={setShowCaptionTranslationPanel}
        translationEnabled={translationEnabled}
        setTranslationEnabled={setTranslationEnabled}
        stopTranslation={stopTranslation}
        startTranslation={startTranslation}
        selectedLanguage={selectedLanguage}
        changeTranslationLanguage={changeTranslationLanguage}
        setSelectedLanguage={setSelectedLanguage}
        translationStatus={translationStatus}
        mMeeting={mMeeting}
      />

      {/* Virtual Background Modal */}
      {showVirtualBackgroundModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setShowVirtualBackgroundModal(false)}
          ></div>

          {/* Modal Content */}
          <div className="fixed left-0 top-[80px] bg-[#060621] rounded-lg shadow-xl w-full max-w-md mx-4 border border-gray-600">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-600">
              <h3 className="text-lg font-semibold text-white">
                Choose Virtual Background
              </h3>
              <button
                onClick={() => setShowVirtualBackgroundModal(false)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Blur Controls */}
            <div className="p-4 border-b border-gray-600">
              <div className="space-y-4">
                {/* Blur Toggle */}
                <div className="flex items-center justify-between">
                  <span className="text-white text-sm font-medium">
                    BLUR YOUR BACKGROUND
                  </span>
                  <div className="flex bg-gray-700 p-1 rounded">
                    <button
                      onClick={() => {
                        setBlurEnabled(false);
                        handleStartVirtualBackground("", false);
                      }}
                      className={`px-3 py-1 text-xs font-medium transition-colors ${!blurEnabled
                        ? "bg-[#7700ff] text-white"
                        : "text-gray-400 hover:text-white"
                        }`}
                    >
                      OFF
                    </button>
                    <button
                      onClick={() => {
                        setBlurEnabled(true);
                        handleStartVirtualBackground("", true);
                      }}
                      className={`px-3 py-1 text-xs font-medium transition-colors ${blurEnabled
                        ? "bg-[#7700ff] text-white"
                        : "text-gray-400 hover:text-white"
                        }`}
                    >
                      ON
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Background Options */}
            <div className="p-4 h-[60vh] overflow-y-auto">
              <div className="space-y-3">
                <span className="text-white text-sm font-medium">
                  BLUR YOUR BACKGROUND
                </span>
                <div className="grid grid-cols-2 gap-3">
                  {/* No Background Option */}
                  <button
                    onClick={() => {
                      handleStartVirtualBackground(null);
                      setShowVirtualBackgroundModal(false);
                    }}
                    className={`p-4 rounded-lg border transition-colors ${!virtualBackgroundOn
                      ? "border-[#7700ff] bg-[#7700ff]/10"
                      : "border-gray-600 hover:border-gray-500"
                      }`}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <div className="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center">
                        <svg
                          className="w-6 h-6 text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                        </svg>
                      </div>
                      <span className="text-white text-xs text-center">
                        No Background
                      </span>
                    </div>
                  </button>

                  {/* Upload Image Option - Only show if user is authenticated */}
                  {isAuthenticated && (
                    <>
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept="image/jpeg,image/jpg,image/png,image/gif,image/webp"
                        onChange={handleFileUpload}
                        disabled={uploadingBackground}
                        className="hidden"
                        id="virtual-background-upload-input"
                      />
                      <button
                        type="button"
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          if (!uploadingBackground && fileInputRef.current) {
                            fileInputRef.current.click();
                          }
                        }}
                        disabled={uploadingBackground}
                        className="p-4 rounded-lg border-2 border-dashed border-[#7700ff] hover:border-[#7700ff]/80 transition-colors cursor-pointer w-full disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        <div className="flex flex-col items-center gap-2">
                          <div className="w-12 h-12 bg-gray-700 rounded-lg flex items-center justify-center">
                            {uploadingBackground ? (
                              <svg
                                className="animate-spin h-6 w-6 text-[#7700ff]"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                              >
                                <circle
                                  className="opacity-25"
                                  cx="12"
                                  cy="12"
                                  r="10"
                                  stroke="currentColor"
                                  strokeWidth="4"
                                ></circle>
                                <path
                                  className="opacity-75"
                                  fill="currentColor"
                                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                ></path>
                              </svg>
                            ) : (
                              <svg
                                className="w-6 h-6 text-[#7700ff]"
                                fill="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z" />
                              </svg>
                            )}
                          </div>
                          <div className="flex items-center gap-1">
                            <span className="text-white text-xs text-center">
                              {uploadingBackground
                                ? "UPLOADING..."
                                : "UPLOAD YOUR IMAGE"}
                            </span>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setShowImageSizeInfoDialog(true);
                              }}
                              className="text-gray-400 hover:text-[#7700ff] transition-colors"
                              title="Image size recommendations"
                            >
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </button>
                    </>
                  )}
                </div>

                {/* Custom Backgrounds*/}
                {isAuthenticated && customBackgrounds.length > 0 && (
                  <div className="mt-4">
                    <span className="text-white text-sm font-medium">
                      YOUR CUSTOM BACKGROUNDS
                    </span>
                    <div className="grid grid-cols-2 gap-3 mt-3">
                      {customBackgrounds.map((background) => (
                        <div
                          key={
                            background._id ||
                            background.id ||
                            background.uniqueName
                          }
                          className="relative group"
                        >
                          <button
                            onClick={() => {
                              handleStartVirtualBackground(background.url);
                              setShowVirtualBackgroundModal(false);
                            }}
                            className={`w-full rounded-lg overflow-hidden transition-colors ${virtualBackgroundOn &&
                              selectedBackground === background.url
                              ? "ring-2 ring-[#7700ff]"
                              : "hover:ring-2 hover:ring-gray-500"
                              }`}
                          >
                            <img
                              className="w-full h-20 object-cover"
                              src={
                                background.url?.startsWith("http")
                                  ? background.url
                                  : `${process.env.REACT_APP_BASE_URL || ""}${background.url
                                  }`
                              }
                              alt={
                                background.originalName || "Custom background"
                              }
                              onError={(e) => {
                                console.error(
                                  "Failed to load image:",
                                  background.url
                                );
                                e.target.style.display = "none";
                              }}
                            />
                          </button>
                          <button
                            onClick={(e) =>
                              handleDeleteBackground(
                                background._id || background.id,
                                e
                              )
                            }
                            className="absolute top-1 right-1 p-1 bg-red-600 hover:bg-red-700 rounded-full opacity-0 group-hover:opacity-100 transition-opacity"
                            title="Delete background"
                          >
                            <svg
                              className="w-4 h-4 text-white"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Default Background Images Grid */}
                <div
                  className={`grid grid-cols-2 gap-3 ${isAuthenticated && customBackgrounds.length > 0
                    ? "mt-4"
                    : "mt-4"
                    }`}
                >
                  <span className="col-span-2 text-white text-sm font-medium">
                    DEFAULT BACKGROUNDS
                  </span>
                  {backgroundImageUrls.map((background, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        handleStartVirtualBackground(background);
                        setShowVirtualBackgroundModal(false);
                      }}
                      className={`rounded-lg overflow-hidden transition-colors ${virtualBackgroundOn && selectedBackground === background
                        ? "ring-2 ring-[#7700ff]"
                        : "hover:ring-2 hover:ring-gray-500"
                        }`}
                    >
                      <img
                        className="w-full h-20 object-cover"
                        src={background}
                        alt={`Background ${index + 1}`}
                      />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Image Size Info Dialog */}
      {showImageSizeInfoDialog && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => setShowImageSizeInfoDialog(false)}
          ></div>

          {/* Modal Content */}
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-md mx-4 text-white shadow-xl">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-white">
                Recommended Image Sizes
              </h3>
              <button
                onClick={() => setShowImageSizeInfoDialog(false)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Content */}
            <div className="space-y-4">
              <p className="text-gray-300 text-sm">
                For optimal virtual background performance, we recommend using
                images with the following specifications:
              </p>

              <div className="bg-gray-800/50 rounded-lg p-4 space-y-3">
                <div>
                  <h4 className="text-white font-medium mb-2">
                    Recommended Dimensions:
                  </h4>
                  <ul className="text-gray-300 text-sm space-y-1 ml-4 list-disc">
                    <li>Minimum: 1280 x 720 pixels (16:9 aspect ratio)</li>
                    <li>Optimal: 1920 x 1080 pixels (Full HD)</li>
                    <li>Maximum: 3840 x 2160 pixels (4K)</li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-white font-medium mb-2">File Size:</h4>
                  <ul className="text-gray-300 text-sm space-y-1 ml-4 list-disc">
                    <li>Recommended: Under 5 MB</li>
                    <li>Maximum: 10 MB</li>
                  </ul>
                </div>

                <div>
                  <h4 className="text-white font-medium mb-2">
                    Supported Formats:
                  </h4>
                  <p className="text-gray-300 text-sm ml-4">
                    JPEG, PNG, GIF, WebP
                  </p>
                </div>
              </div>

              <p className="text-gray-400 text-xs italic">
                Note: Images with a 16:9 aspect ratio will provide the best
                results and prevent distortion.
              </p>
            </div>

            {/* Footer */}
            <div className="flex justify-end mt-6">
              <button
                onClick={() => setShowImageSizeInfoDialog(false)}
                className="px-4 py-2 rounded-lg bg-[#7700ff] text-white hover:bg-[#7700ff]/80 transition-colors"
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Delete Background Confirmation Modal */}
      {showDeleteConfirmModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* Overlay */}
          <div
            className="absolute inset-0 bg-black bg-opacity-50"
            onClick={() => {
              setShowDeleteConfirmModal(false);
              setBackgroundToDelete(null);
            }}
          ></div>

          {/* Modal Content */}
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-md mx-4 text-white shadow-xl">
            {/* Header */}
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-white">
                Delete Background?
              </h3>
              <button
                onClick={() => {
                  setShowDeleteConfirmModal(false);
                  setBackgroundToDelete(null);
                }}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Content */}
            <div className="mb-6">
              <p className="text-gray-300 text-base">
                Are you sure you want to delete this background? This action
                cannot be undone.
              </p>
            </div>

            {/* Footer */}
            <div className="flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowDeleteConfirmModal(false);
                  setBackgroundToDelete(null);
                }}
                className="px-4 py-2 rounded-lg bg-transparent border border-gray-600 text-white hover:bg-gray-700/50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={confirmDeleteBackground}
                className="px-4 py-2 rounded-lg bg-red-600 text-white hover:bg-red-700 transition-colors"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Start Recording Confirmation */}
      {showStartRecordingModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowStartRecordingModal(false)}
          />
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-lg mx-4 text-white">
            <h3 className="text-xl font-bold mb-4 uppercase text-center">
              Start recording this meeting?
            </h3>
            <p className="text-base text-gray-300 mb-6 text-center">
              Participants will see a notice that the meeting is being recorded.
            </p>
            <div className="flex gap-3 mt-10 justify-end">
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-transparent border border-white text-white hover:bg-white/10"
                onClick={() => setShowStartRecordingModal(false)}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-[#7700ff] text-white hover:bg-white/10"
                onClick={handleConfirmStartRecording}
              >
                Start Recording
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Recording consent notice for participants */}
      {showRecordingConsentModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowRecordingConsentModal(false)}
          />
          <div className="relative bg-[#060621] border border-gray-700 rounded-2xl p-6 w-full max-w-xl mx-4 text-white">
            <h3 className="text-xl font-bold uppercase text-center mb-2">
              This session is being recorded.
            </h3>
            <p className="text-base text-gray-300 mb-6 mt-2 text-center">
              If you stay, you're giving consent to record audio and video.{" "}
              <br />
              Don't want to be recorded? You can leave anytime.
            </p>
            <div className="flex gap-3 mt-10 flex-col sm:flex-row sm:justify-end">
              <button
                className="px-4 py-2 w-1/2 rounded-lg bg-transparent border border-white text-white hover:bg-white/10"
                onClick={handleLeaveConfirm}
              >
                Leave Meeting
              </button>
              <button
                className="px-4 py-2 w-1/2 rounded-lg bg-[#7700FF]  text-white hover:bg-white/10"
                onClick={() => setShowRecordingConsentModal(false)}
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}

      {showLeaveModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          {/* dim background */}
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setShowLeaveModal(false)}
          />
          {/* center content */}
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-lg mx-4 text-white shadow-2xl">
            {/* Close Button */}
            <div className="flex items-center justify-end mb-4">
              <button
                onClick={() => setShowLeaveModal(false)}
                className="text-gray-400 hover:text-white transition-colors p-2 hover:bg-gray-700/50 rounded-full"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Title */}
            <h3 className="text-xl font-bold text-center mb-2">Leave Room?</h3>

            {/* Description */}
            <p className="text-gray-300 text-center mb-6 text-sm">
              You're about to leave this room. Choose how you'd like to proceed:
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col gap-3">
              {/* Stay */}
              <button
                className="w-full px-6 py-3 rounded-lg bg-gray-600 hover:bg-gray-700 text-white font-medium transition-colors"
                onClick={() => setShowLeaveModal(false)}
              >
                Stay in Room
              </button>

              {/* Leave */}
              <button
                className="w-full px-6 py-3 rounded-lg bg-red-600 hover:bg-red-700 text-white font-medium transition-colors"
                onClick={handleLeaveConfirm}
              >
                Leave Room
              </button>

              {/* End for all - moderators only */}
              {meetingRole === "moderator" && (
                <button
                  className="w-full px-6 py-3 rounded-lg border-2 border-red-600 text-red-400 hover:bg-red-600/10 hover:text-red-300 font-medium transition-colors"
                  onClick={handleEndForAll}
                >
                  End Session for All
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes floatUp{0%{transform:translateY(0) translateX(0) scale(1);opacity:1}25%{transform:translateY(-25vh) translateX(20px) scale(1.1);opacity:.85}50%{transform:translateY(-50vh) translateX(0) scale(1.15);opacity:.7}75%{transform:translateY(-75vh) translateX(-20px) scale(1.1);opacity:.5}100%{transform:translateY(-100vh) translateX(0) scale(1);opacity:0}}`}</style>
      <div
        className="pointer-events-none fixed"
        style={{ bottom: 72, left: "7%", zIndex: 1302 }}
      >
        {recentReactions.slice(-6).map((r) => (
          <div
            key={r.id}
            className="mt-1 flex flex-col items-center"
            style={{
              animation: "floatUp 6s ease-out forwards",
              filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.2))",
            }}
          >
            <div className="text-[28px] mb-0.5">{r.emoji}</div>
            <div className="mt-0.5 px-1.5 py-0.5 rounded bg-black/60 text-white text-[10px]">
              {/* {getParticipantName(r.from)} */}
              {r.from}
            </div>
          </div>
        ))}
      </div>

      {/* Polls Modal */}
      {showPollsModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowPollsModal(false)}
          />
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-2xl mx-4 text-white max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-end mb-2">
              <button
                onClick={() => setShowPollsModal(false)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <h3 className="text-xl font-bold uppercase text-center mb-6">
              SELECT A POLL TO LAUNCH
            </h3>

            <div className="space-y-4 mb-6">
              <div className="relative">
                <select
                  value={selectedPoll?.id || ""}
                  onChange={(e) => {
                    const pollId = e.target.value;
                    const poll = polls.find((p) => p.id === pollId);
                    setSelectedPoll(poll || null);
                  }}
                  className="w-full px-4 py-3 bg-[#1a1a2e] border border-gray-600 rounded-lg text-white text-sm focus:outline-none focus:border-[#7700FF] appearance-none"
                  disabled={loadingPolls}
                >
                  <option value="">
                    {loadingPolls ? "Loading polls..." : "Select a Poll"}
                  </option>
                  {polls.map((poll) => (
                    <option key={poll.id} value={poll.id}>
                      {poll.question || "Untitled Poll"}
                    </option>
                  ))}
                </select>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="absolute right-4 top-1/2 transform -translate-y-1/2 text-white pointer-events-none"
                >
                  <path d="M7 10l5 5 5-5z" />
                </svg>
              </div>

              {/* Selected Poll Preview */}
              {selectedPoll && (
                <div className="p-4 bg-[#1a1a2e] border border-gray-600 rounded-lg">
                  <div className="text-white font-medium mb-2">
                    {selectedPoll.question}
                  </div>
                  {selectedPoll.options && selectedPoll.options.length > 0 && (
                    <div className="space-y-2">
                      {selectedPoll.options.map((option, index) => (
                        <div key={index} className="text-gray-300 text-sm pl-4">
                          • {option.text}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* Action Buttons */}
            <div className="flex gap-3 justify-end">
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-transparent border border-white text-white hover:bg-white/10"
                onClick={() => {
                  setShowPollsModal(false);
                  setSelectedPoll(null);
                }}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 rounded-lg w-1/2 bg-[#7700FF] text-white hover:bg-[#7700FF]/80 disabled:opacity-50 disabled:cursor-not-allowed"
                onClick={handleLaunchPoll}
                disabled={!selectedPoll || loadingPolls}
              >
                Launch Poll
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Poll Results Modal */}
      {showPollResultsModal && pollResults && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="absolute inset-0 bg-black/60"
            onClick={() => setShowPollResultsModal(false)}
          />
          <div className="relative bg-[#060621] border border-gray-700 rounded-xl p-6 w-full max-w-2xl mx-4 text-white max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-xl font-bold uppercase">POLL RESULTS</h3>
              <button
                onClick={() => setShowPollResultsModal(false)}
                className="text-gray-400 hover:text-white transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Question */}
            <div className="mb-6">
              <p className="text-white text-lg font-medium">
                {pollResults.question}
              </p>
            </div>

            {/* Results */}
            <div className="space-y-4 mb-6">
              {pollResults.options &&
                pollResults.options.map((option, index) => {
                  const totalVotes = pollResults.votes?.length || 0;
                  const percentage =
                    totalVotes > 0
                      ? Math.round((option.votes / totalVotes) * 100)
                      : 0;

                  return (
                    <div
                      key={index}
                      className="p-4 rounded-lg border border-gray-600 bg-[#1a1a2e]"
                    >
                      <div className="flex items-center justify-between mb-2">
                        <span className="text-white text-sm font-medium">
                          {option.text}
                        </span>
                        <span className="text-gray-400 text-sm">
                          {percentage}%
                        </span>
                      </div>
                      <div className="w-full bg-gray-700 rounded-full h-3">
                        <div
                          className="bg-[#7700ff] h-3 rounded-full transition-all"
                          style={{ width: `${percentage}%` }}
                        />
                      </div>
                      <p className="text-gray-400 text-xs mt-2">
                        {option.votes} vote{option.votes !== 1 ? "s" : ""}
                      </p>

                      {/* Show participants who voted if enabled */}
                      {pollResults.settings?.showParticipantsWhoVoted &&
                        !pollResults.settings?.anonymousVoting && (
                          <div className="mt-3 pt-3 border-t border-gray-700">
                            <p className="text-gray-400 text-xs mb-2">
                              Voted by:
                            </p>
                            <div className="flex flex-wrap gap-2">
                              {pollResults.votes
                                ?.filter((vote) =>
                                  vote.optionIndices.includes(index)
                                )
                                .map((vote, voteIndex) => (
                                  <span
                                    key={voteIndex}
                                    className="text-xs bg-gray-700 px-2 py-1 rounded"
                                  >
                                    {vote.participantName}
                                  </span>
                                ))}
                            </div>
                          </div>
                        )}
                    </div>
                  );
                })}
            </div>

            {/* Total Votes */}
            <div className="text-center mb-4">
              <p className="text-gray-400 text-sm">
                Total Votes: {pollResults.votes?.length || 0}
              </p>
            </div>

            {/* Close Button */}
            <div className="flex justify-center">
              <button
                onClick={() => setShowPollResultsModal(false)}
                className="px-6 py-2 rounded-lg bg-[#7700ff] text-white hover:bg-[#7700ff]/80 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Profile Confirmation Modal */}
      {showProfileConfirmModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
          <div className="relative bg-primaryDarkBlue rounded-2xl p-8 w-full max-w-md mx-4 shadow-2xl">
            {/* Close Button */}
            <button
              onClick={() => setShowProfileConfirmModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Title */}
            <h2 className="text-2xl font-semibold text-white text-center mb-4">
              Go to Profile?
            </h2>

            {/* Description */}
            <p className="text-gray-400 text-center mb-8">
              You're about to open your profile page. This will open in a new
              tab.
            </p>

            {/* Buttons */}
            <div className="space-y-3">
              {/* Stay Button */}
              <button
                onClick={() => setShowProfileConfirmModal(false)}
                className="w-full py-3 px-4 bg-[#4a5568] hover:bg-[#5a6578] text-white rounded-lg font-medium transition-colors"
              >
                Stay in Room
              </button>

              {/* Go to Profile Button */}
              <button
                onClick={() => {
                  setShowProfileConfirmModal(false);
                  window.open("/dashboard/profile", "_blank");
                }}
                className="w-full py-3 px-4 bg-[#dc2626] hover:bg-[#b91c1c] text-white rounded-lg font-medium transition-colors"
              >
                Go to Profile
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Breakout Rooms Modal - Rendered at TopBar level so it persists when ToolsDropdown closes */}
      {
        ["moderator", "co-host"].includes(meetingRole) && (
          <BreakoutRoomsModal
            isOpen={showBreakoutRoomsModal}
            onClose={() => {
              console.log("Closing breakout rooms modal from TopBar");
              setShowBreakoutRoomsModal(false);
            }}
            meetingRole={meetingRole}
          />
        )
      }
      {
        !["moderator", "co-host"].includes(meetingRole) && (
          <BreakoutRoomsParticipantPanel
            isOpen={showBreakoutRoomsModal}
            onClose={() => {
              console.log("Closing breakout rooms participant panel from TopBar");
              setShowBreakoutRoomsModal(false);
            }}
          />
        )
      }
    </div>
  );
};

export default TopBar;
